/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/259-crying2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zM5 11.5a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zm0-3a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zM5.5 6h-2a.5.5 0 010-1h2a.5.5 0 010 1zm4.354 7.229a.498.498 0 01-.708 0C9.074 13.157 8.686 13 8 13s-1.075.157-1.146.229a.5.5 0 01-.707-.707c.471-.471 1.453-.521 1.854-.521s1.383.051 1.854.521a.5.5 0 010 .707zM12 11.5a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zm0-3a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zm.5-2.5h-2a.5.5 0 010-1h2a.5.5 0 010 1z"/>'
  }
})
